(function ($) {

    $.fn.HeroImage = function () {

        return $(this).each(function () {
            var container = this;
            var urls = [];
            $('input', container).each(function () { urls.push($(this).val()); });
            if (urls.length) {
                var indextoshow = Math.floor(Math.random() * urls.length) + 0;
                var string = "url('" + urls[indextoshow] + "') center center no-repeat";
                $(container).css({ background: string, 'background-size': 'cover' });
            }
        });

    };
    $(document).ready(function () {
        $('.HeroImage').HeroImage();
    });
}(jQuery));